import React from 'react';

import { useSettings } from '@atlas/core';
import { Loader } from '@atlas/ui';

export const LayoutLoader = ({ children }) => {
  const { lang } = useSettings();

  if (!lang) {
    return <Loader className="layout-loader" height={48} width={48} />;
  }

  return children;
};
